import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { isInValidValue } from '../../../../helpers/value'
import classes from '../../../index.module.scss'
import {
  checkEmailValid,
  checkInvalidInputVal,
  checkPhoneValid,
} from '../helper'
import { GroupRadioContract } from './GroupRadio'
import { InputField } from './InputFields'
import { ALL_CONTRACTION_FIELDS, CONTRACTION_FIELD_KEYS } from './constants'

const FIRST_ROW_FIELDS = ALL_CONTRACTION_FIELDS.slice(0, 2)
const SECOND_ROW_FIELDS = ALL_CONTRACTION_FIELDS.slice(2, 6)
const THIRD_ROW_FIELDS = ALL_CONTRACTION_FIELDS.slice(6, 9)

export const ContractForm = ({
  form,
  setForm,
  isValid,
  setIsValid,
  userProfile,
}) => {
  const locale = useSelector((state) => state.i18n.locale)

  const onChange = (key, event) => {
    const eventValue = event.target.value

    if (!!eventValue.trim()) {
      setIsValid({
        ...isValid,
        [key]: true,
      })
    }

    if (key === CONTRACTION_FIELD_KEYS.PHONE) {
      if (!!eventValue.trim()) {
        if (!checkPhoneValid(eventValue)) {
          return
        }
      }
    }

    if (key === CONTRACTION_FIELD_KEYS.EMAIL) {
      if (!!eventValue.trim()) {
        setIsValid({
          ...isValid,
          [key]: checkEmailValid(eventValue),
        })
      } else {
        setIsValid({
          ...isValid,
          [key]: true,
        })
      }
    }

    setForm({ ...form, [key]: eventValue })
  }

  const invalidFieldValCondition = (itemKey) => {
    return !!isValid[itemKey] || isInValidValue(isValid[itemKey])
  }

  const onChangeLocale = (value) => {
    setForm({
      ...form,
      languageCode: value,
    })
  }

  useEffect(() => {
    let defaultForm = {}
    if (userProfile) {
      const allFieldFilled = Object.values(CONTRACTION_FIELD_KEYS).map(
        (item) => {
          return {
            [item]: userProfile[item] || '',
            taxCode: userProfile?.companyTaxCode,
            title: userProfile?.jobTitle || '',
          }
        },
      )
      defaultForm = Object.assign({}, ...allFieldFilled)
    }
    setForm(defaultForm)
  }, [userProfile])

  return (
    <>
      <div>
        <GroupRadioContract
          onChange={onChangeLocale}
          activeValue={form?.languageCode || locale}
        />
      </div>
      <div className={[classes.content, 'flexColumn'].join(' ')}>
        {FIRST_ROW_FIELDS.map((item) => (
          <div key={item.key}>
            <InputField
              item={item}
              isValid={isValid}
              form={form}
              onChange={onChange}
              otherProps={{
                containerStyle: invalidFieldValCondition(item.key)
                  ? { marginBottom: 20 }
                  : { marginBottom: 30 },
              }}
            />
          </div>
        ))}

        <div className="flexRow">
          {SECOND_ROW_FIELDS.map((item, index) => (
            <div
              key={item.key}
              style={inputAppendStyle(
                index === 3,
                invalidFieldValCondition(item.key),
              )}
            >
              <InputField
                item={item}
                isValid={isValid}
                form={form}
                onChange={onChange}
                otherProps={{
                  textInvalidEllipsis: true,
                  styleTextInvalid: textInvalidAppendStyle(
                    checkInvalidInputVal(form[item.key]),
                  ),
                }}
              />
            </div>
          ))}
        </div>

        <div className="flexRow">
          {THIRD_ROW_FIELDS.map((item) => (
            <div
              key={item.key}
              style={inputAppendStyle(
                false,
                invalidFieldValCondition(item.key),
              )}
            >
              <InputField
                item={item}
                isValid={isValid}
                form={form}
                onChange={onChange}
                otherProps={{
                  textInvalidEllipsis: true,
                  styleTextInvalid: textInvalidAppendStyle(
                    checkInvalidInputVal(form[item.key]),
                  ),
                  labelTextEllipsis: true,
                }}
              />
            </div>
          ))}
          <Element style={inputAppendStyle(true)} />
        </div>
      </div>
    </>
  )
}

const inputAppendStyle = (isLastItemInRow, notHasValidateText) => {
  const style = {
    marginBottom: notHasValidateText ? 20 : 45,
    maxWidth: 205,
    width: '25%',
    marginRight: isLastItemInRow ? 0 : 12,
  }

  return style
}

const textInvalidAppendStyle = (isBlankValidate) => {
  return isBlankValidate ? { bottom: -28 } : { bottom: -32 }
}
